import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { AcaoJudicialRow } from 'src/modules/motor-credito/serasa/serasa.pj.types'

export type AcaoJudicialProps = {
    acaoJudicial: AcaoJudicialRow
}

export default function AcaoJudicial({ acaoJudicial }: AcaoJudicialProps) {
    return (
        <>
            <Divider textAlign="center">Ação Judicial</Divider>
            {acaoJudicial && (
                <Grid
                    container
                    spacing={1}
                    sx={{
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 5,
                        paddingRight: 5
                    }}
                >
                    <GridItem label="Total Ocorrências" value={acaoJudicial.total_ocorrencias?.toFixed(0)} xs={6} />
                    <GridItem label="Total Valores" value={acaoJudicial.total_valores?.toFixed(2)} xs={6} />

                    {acaoJudicial.ocorrencias?.map((ocorrencia, index) => (
                        <Grid key={index} container spacing={1}>
                            <GridItem label="Data" value={formatDate(ocorrencia.data, 'dd/MM/yyyy')} xs={6} />
                            <GridItem label="Natureza" value={ocorrencia.natureza} xs={6} />
                            <GridItem label="Valor" value={ocorrencia.valor?.toFixed(2)} xs={6} />
                            <GridItem label="Distância" value={ocorrencia.dist} xs={6} />
                            <GridItem label="Vara" value={ocorrencia.vara} xs={6} />
                            <GridItem label="Cidade" value={ocorrencia.cidade} xs={6} />
                            <GridItem label="UF" value={ocorrencia.uf} xs={6} />
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    )
}
